<template>
  <v-container class="pa-0">
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card class="py-7 px-3">
        <v-row
          no-gutters
          justify="center"
          style="color: red"
        >
          Reservation
        </v-row>
        <v-row
          no-gutters
          justify="center"
        >
          <h2>快速訂房</h2>
        </v-row>

        <v-card-text class="mt-6">
          <DatePickerSearch
            :is-fast="true"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DatePickerSearch from '/src/components/DatePickerSearch.vue'

export default {
  components: {
    DatePickerSearch
  },
  data () {
    return {
      dialog: true
    }
  }
}
</script>

<style>
</style>
